export const BASE_URL = "http://back-test.bitrah.com/api/v1";
export const BITRAH_URL = "http://bitrah.com";
export const ASSETS_URL = "http://excoino.com/";
